import { useCallback } from "react";
import toast from "react-hot-toast";

export default () => {
  const addNotification = useCallback((data = {}) => {
    const settings = {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: true,
      newestOnTop: false,
      closeOnClick: false,
      theme: "light"
    };

    if (data.ok)
      toast.success(data.message, settings);
    else toast.error(data.message, settings);
  }, []);

  return { addNotification };
};
